import React from "react"

const LRHIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.99992 19.1667C15.0625 19.1667 19.1666 15.0626 19.1666 10C19.1666 4.9374 15.0625 0.833344 9.99992 0.833344C4.93731 0.833344 0.833252 4.9374 0.833252 10C0.833252 15.0626 4.93731 19.1667 9.99992 19.1667ZM9.99992 17.3333C14.05 17.3333 17.3333 14.0501 17.3333 10C17.3333 5.94992 14.05 2.66668 9.99992 2.66668C5.94983 2.66668 2.66659 5.94992 2.66659 10C2.66659 14.0501 5.94983 17.3333 9.99992 17.3333Z"
      fill="currentColor"
    />
    <path
      d="M5.23315 8.16656H6.01368V11.1435H7.56264V11.8332H5.23315V8.16656Z"
      fill="currentColor"
    />
    <path
      d="M9.45739 10.5203H8.88258V11.8332H8.10205V8.16656H9.82042C10.5828 8.16656 11.0547 8.66877 11.0547 9.34643C11.0547 9.99385 10.6494 10.3387 10.25 10.4355L11.0729 11.8332H10.1774L9.45739 10.5203ZM9.70546 8.83818H8.88863V9.84863H9.70546C10.0201 9.84863 10.2561 9.64896 10.2561 9.34038C10.2561 9.0318 10.0201 8.83818 9.70546 8.83818Z"
      fill="currentColor"
    />
    <path
      d="M14.1536 10.2903H12.4231V11.8272H11.6426V8.16656H12.4231V9.60661H14.1536V8.16656H14.9402V11.8332H14.1536V10.2903Z"
      fill="currentColor"
    />
  </svg>
)

export default LRHIcon
